import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Section from '../global/section';
import Top from '../top';

const StyledLearn = styled.div`
	section {
		text-align: center;
		.circle-container {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
			margin: 3rem auto 0;

			.circle-link {
				width: 20%;

				.circle {
					display: flex;
					justify-content: center;
					align-items: center;
					flex-direction: column;
					position: relative;
					background-size: cover;
					background-position: center;
					background-repeat: no-repeat;
					margin: 5px;

					&::after {
						content: '';
						display: block;
						padding-bottom: 100%;
					}

					img {
						@media screen and (-ms-high-contrast: active),
							(-ms-high-contrast: none) {
							height: 100%;
						}
					}

					p {
						font-weight: 700;
						/* margin-top: 0.5rem; */
						color: ${(p) => p.theme.color.light};
						letter-spacing: 0.125em;
						padding: 5px;
						position: absolute;
						top: 0;
						right: 0;
						bottom: 0;
						left: 0;
						opacity: 0;
						transition: opacity 300ms;
						transition-delay: 50ms;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						z-index: 1;

						&::after {
							content: '';
							position: absolute;
							top: 0;
							right: 0;
							bottom: 0;
							left: 0;
							background-color: ${(p) => p.theme.color.blue};
							opacity: 0.7;
							z-index: -1;
						}

						&:hover {
							opacity: 1;
						}
					}
				}
			}
			@media all and (max-width: 1000px) {
				width: 85%;
			}
			@media all and (max-width: 868px) {
				width: 100%;
			}
			@media all and (max-width: 768px) {
				width: 90%;
				.circle-link {
					width: 50%;
				}
			}
			@media all and (max-width: 450px) {
				width: 100%;
			}
		}
	}
`;

export default ({ data }) => {
	const { top, title, circles } = data;
	return (
		<StyledLearn>
			<Section bg="white">
				<Top color="blue">{top}</Top>
				<h2>{title}</h2>
				<div className="circle-container">
					{circles.map((x, i) => (
						<Link className="circle-link" to={x.link} key={i}>
							<div
								className="circle"
								style={{ backgroundImage: `url(${x.photo})` }}
							>
								<p>{x.text}</p>
							</div>
						</Link>
					))}
				</div>
			</Section>
		</StyledLearn>
	);
};
